/**
 * Where the admin console lives for this copy of the app: the team's own site,
 * on its own origin (measure-map-online-console). Admins get there from the
 * menu, and "View as user" hands a session from there to /impersonate here,
 * which only believes messages from this origin.
 */
export function consoleOrigin(): string {
  const host = location.hostname;
  if (host === 'localhost' || host === '127.0.0.1') {
    return `${location.protocol}//${host}:4300`;
  }
  if (host === 'app.measuremaponline.com') {
    return 'https://console.measuremaponline.com';
  }
  return 'https://mm-online-dev-console.web.app';
}
